document.addEventListener('DOMContentLoaded', function (event) {
  anchor();
  addLinkToPrivacyPolicy();
});

anchor = () => {
  // Check anchor is set
  let hasAnchor = window.location.hash;
  if (hasAnchor) {
    let anchor = hasAnchor.substring(1);
    let form = document.getElementById(anchor);
    // Check for with hash id exists
    if (form) {
      // Set position for smooth scroll
      const y = form.getBoundingClientRect().top + window.scrollY - 105;
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
    }
  }
};

addLinkToPrivacyPolicy = () => {
  const element = $('[for*="-datenschutz"]');

  if (element.length) {
    let url = '/global/datenschutz';

    $(element).html(
      $(element)
        .html()
        .replace(
          'Datenschutzhinweise',
          '<a target="_blank" href="' + url + '" class="privacy">Datenschutzhinweise</a>',
        ),
    );
  }
};
